import React from 'react';
import 'twin.macro';
import { createPortal } from 'react-dom';
import { DragOverlay } from '@dnd-kit/core';
import { ITreeNode } from 'components/Tree2/types';
import NodeIcon from 'components/Tree2/NodeIcon';

interface Props {
  active?: ITreeNode;
}

export function DraggableOverlay({ active }: Props) {
  return createPortal(
    <DragOverlay dropAnimation={null}>
      {active ? (
        <div tw="inline-flex items-center gap-x-2 bg-white p-1 rounded">
          <NodeIcon icon={active?.icon} /> {active?.label}
        </div>
      ) : null}
    </DragOverlay>,
    document.body,
  );
}
